import { nString } from '@hidat/huijs-common';
import { ExtendedBrandingInterface } from '@splixer/common';
import { Expose } from 'class-transformer';

// WET alert!  Duplicated from admin_common....
export class PlayerExtendedBranding implements ExtendedBrandingInterface {
  @Expose({ name: 'color_scheme' })
  colorScheme?: 'dark' | 'light' | undefined | null = undefined;
  @Expose({ name: 'background_color' })
  backgroundColor?: nString = undefined;

  @Expose({ name: 'background_image_url' })
  backgroundImageUrl?: nString = undefined;
  @Expose({ name: 'banner_image_url' })
  bannerImageUrl?: nString = undefined;
  @Expose({ name: 'avatar_image_url' })
  avatarImageUrl?: nString = undefined;
  @Expose({ name: 'thumbnail_image_url' })
  thumbnailImageUrl?: nString = undefined;

  @Expose()
  previousImageUrl?: nString = undefined;
  @Expose()
  previousDescription?: nString = undefined;
}
